var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDriverPreferences(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 129,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.09 56.692c0 6.969 11.273 14.061 11.273 14.061s11.274-7.09 11.274-14.061V32.77H45.09v23.92",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.854 43.073V30.558l-2.59-1.85c-1.578-1.126-3.483.537-3.243 2.83l.592 5.657c.35 3.365 2.591 5.878 5.241 5.878",
    id: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.738 43.073V30.558l2.59-1.85c1.577-1.126 3.482.537 3.242 2.83l-.59 5.657c-.353 3.365-2.593 5.878-5.242 5.878",
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.228 18.046a.63.63 0 0 0-.796.413.631.631 0 0 0 .411.794l8.956 2.844c.185-.23.357-.468.51-.726.073-.123.14-.252.214-.375l-9.295-2.95",
    id: "d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44 13.522a.634.634 0 1 0-.428 1.192l9.171 3.289c.199-.378.402-.753.594-1.134L6.44 13.522",
    id: "e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.226 8.633a.634.634 0 0 0-.479 1.173l9.54 3.885c.172-.385.344-.77.511-1.159L8.226 8.633",
    id: "f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.14 18.046a.633.633 0 1 1 .383 1.207l-8.955 2.844a6.338 6.338 0 0 1-.511-.726c-.073-.123-.14-.252-.214-.375l9.296-2.95",
    id: "g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.927 13.522a.634.634 0 0 1 .428 1.192l-9.171 3.289c-.199-.378-.403-.753-.596-1.134l9.339-3.347",
    id: "h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.141 8.633a.633.633 0 0 1 .478 1.173L1.08 13.69c-.174-.385-.345-.77-.513-1.159l9.574-3.899",
    id: "i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.987.519C65.22.524 75.429 11.036 75.374 18.434v8.895c.45.405.698.969.718 1.547 1.174.123 2.179 1.478 2 3.18l-.59 5.658c-.282 2.69-1.77 4.836-3.71 5.588-1.455 4.391-4.12 8.033-7.7 10.932l-.001 1.882 25.86 5.044a14.693 14.693 0 0 1 7.212 3.68l.298.286a13.903 13.903 0 0 1 3.924 7.486l6.07 34.539a11.818 11.818 0 0 1-7.542 13.13l-16.04 5.93-62.233-.028-15.926-5.899A11.818 11.818 0 0 1 .18 107.16l6.067-34.563a13.86 13.86 0 0 1 3.922-7.475 14.701 14.701 0 0 1 7.505-3.96l25.871-5.045v-1.882c-3.579-2.9-6.244-6.54-7.7-10.932-1.94-.752-3.428-2.897-3.709-5.588l-.592-5.657c-.178-1.703.827-3.058 2.002-3.182.021-.648.33-1.277.888-1.687l.001-7.342-.022-2.159.067-.051C35.216 10.29 45.113.516 54.987.519z",
    id: "j"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.155 12c9.335.004 18.645 9.539 18.595 16.249l.001 8.067c.41.368.636.88.654 1.403 1.071.113 1.987 1.342 1.824 2.885l-.539 5.131c-.257 2.441-1.615 4.387-3.384 5.069-1.327 3.982-3.757 7.285-7.022 9.914l-.001 1.706 23.596 4.578a13.407 13.407 0 0 1 6.54 3.31l.3.285a12.605 12.605 0 0 1 3.581 6.8l5.528 31.279a10.736 10.736 0 0 1-6.868 11.944L78.326 126l-56.762-.025-14.53-5.352a10.736 10.736 0 0 1-6.862-11.94l5.525-31.3a12.566 12.566 0 0 1 3.58-6.79 13.415 13.415 0 0 1 6.835-3.59l23.606-4.579v-1.706c-3.265-2.63-5.695-5.932-7.022-9.915-1.77-.681-3.128-2.627-3.384-5.068l-.54-5.13c-.162-1.545.754-2.775 1.827-2.886a1.97 1.97 0 0 1 .81-1.53v-6.67l-.02-1.948.06-.045c.672-6.663 9.7-15.528 18.706-15.526z",
    fill: "#40AE29",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.155 12c9.335.004 18.645 9.539 18.595 16.249l.001 8.067c.41.368.636.88.654 1.403 1.071.113 1.987 1.342 1.824 2.885l-.539 5.131c-.257 2.441-1.615 4.387-3.384 5.069-1.327 3.982-3.757 7.285-7.022 9.914l-.001 1.706 23.596 4.578a13.407 13.407 0 0 1 6.54 3.31l.3.285a12.605 12.605 0 0 1 3.581 6.8l5.528 31.279a10.736 10.736 0 0 1-6.868 11.944L140.326 126l-56.762-.025-14.53-5.352a10.736 10.736 0 0 1-6.862-11.94l5.525-31.3a12.566 12.566 0 0 1 3.58-6.79 13.415 13.415 0 0 1 6.835-3.59l23.606-4.579v-1.706c-3.265-2.63-5.695-5.932-7.022-9.915-1.77-.681-3.128-2.627-3.384-5.068l-.54-5.13c-.162-1.545.754-2.775 1.827-2.886a1.97 1.97 0 0 1 .81-1.53v-6.67l-.02-1.948.06-.045c.672-6.663 9.7-15.528 18.706-15.526z",
    fill: "#40AE29",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.186 126.183 62.233.028 16.04-5.93a11.818 11.818 0 0 0 7.541-13.13l-6.07-34.539a13.903 13.903 0 0 0-3.924-7.486 14.693 14.693 0 0 0-7.51-3.966l-37.133-7.243-37.144 7.245a14.701 14.701 0 0 0-7.505 3.959 13.86 13.86 0 0 0-3.923 7.475l-6.066 34.563a11.818 11.818 0 0 0 7.535 13.125l15.926 5.9z",
    fill: "#40AE29"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.08,
    fill: "#000",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.068 .519)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.08,
    fill: "#000",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.068 .519)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.08,
    fill: "#000",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.638 58.49c9.674-4.383 15.953-12.125 15.953-23.31V24.777c0-11.884-9.056-21.519-20.228-21.519-11.17 0-20.227 9.635-20.227 21.519v10.401c0 11.186 6.28 18.928 15.953 23.312a10.3 10.3 0 0 0 8.549 0z",
    fill: "#F0C58A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "m61.141 35.63 3.36-14.135 32.576-3.86 4.495 18.594.347-17.691L79.494 3.34 60.958 17.687l.183 17.942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.532.519c10.235.005 20.442 10.517 20.388 17.915v11.421c-13.784-7.725-27.433-7.884-40.94 0V18.434C61.035 11.02 71.297.516 81.532.519z",
    fill: "#40AE29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.457 30.16a2.184 2.184 0 0 1 .605-3.03c3.76-2.508 9.927-4.119 18.5-4.833 1.18-.098 2.365-.1 3.545-.004 8.62.697 14.81 2.311 18.566 4.842a2.185 2.185 0 0 1 .592 3.034 2.183 2.183 0 0 1-3.033.592c-3.3-2.224-8.752-3.6-16.356-4.132a21.667 21.667 0 0 0-3.084.004c-7.564.552-13 1.93-16.305 4.134a2.18 2.18 0 0 1-3.03-.606z",
    fill: "#02751A"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.02 93c-17.16 0-33.166 11.411-38.081 27.744l-.092.329-.094.387-.098.445-.101.503-.157.866-.165 1c6.036-.346 9.06-.536 9.07-.572 3.67-12.785 16.341-21.776 29.718-21.776 13.03 0 25.472 8.533 29.44 20.858l9.252 1.892-.206-1.236-.198-1.107-.191-.978-.123-.58-.12-.526-.117-.469-.114-.413-.11-.358a7.3 7.3 0 0 0-.055-.158C112.98 103.48 97.463 93 81.02 93z",
    fill: "#586560",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.229 107.574c2.95-3.962 7.014-6.32 10.243-4.817 1.357.632-.666 1.906-1.508 3.861a5.36 5.36 0 0 1-.576 1.021l3.14 1.475a3.975 3.975 0 0 1 1.965 5.145 76.893 76.893 0 0 1-4.742 9.412c-1.416 2.378-4.243 3.525-6.933 2.873l-2.686-.652c-2.637-.64-4.24-3.33-3.516-5.945a99.016 99.016 0 0 1 3.74-10.98c.195-.482.461-.914.78-1.289z",
    fill: "#F0C58A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.442 102.3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.08,
    fill: "#000",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.442 102.3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.08,
    fill: "#000",
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.442 102.3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.08,
    fill: "#000",
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.415 107.598c.178.239.24.428.212.58.157.244.295.508.41.789a99.023 99.023 0 0 1 3.74 10.98c.724 2.614-.88 5.305-3.515 5.945l-2.687.652c-2.69.652-5.518-.495-6.933-2.873a76.718 76.718 0 0 1-4.742-9.412 3.974 3.974 0 0 1 1.965-5.145l3.315-1.558a5.393 5.393 0 0 1-.517-.938c-.842-1.955-2.865-3.23-1.508-3.86 3.236-1.507 7.308.863 10.26 4.84z",
    fill: "#F0C58A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.585 102.3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.08,
    fill: "#000",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.585 102.3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.08,
    fill: "#000",
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.585 102.3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F0C58A",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.08,
    fill: "#000",
    xlinkHref: "#i"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M97.594 85.854h15.645a2 2 0 0 0 1.98-2.286l-.423-2.92a2 2 0 0 0-1.979-1.713H97.172a2 2 0 0 0-1.98 2.286l.422 2.92a2 2 0 0 0 1.98 1.713z",
    fill: "#FFDB00"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    mask: "url(#k)",
    d: "M54.788 0h56.333v128.917H54.788z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriverPreferences);
export default __webpack_public_path__ + "static/media/icon-driver-preferences.3fed4d427b5de9301acf286a9e73cc1b.svg";
export { ForwardRef as ReactComponent };